import styled from 'styled-components';

import { Card } from '@components/molecules/Card/Card';

export const StepControlWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;

export const MfaCard = styled(Card)`
    ${Card.TitleSecondary} {
        margin-bottom: 24px;
    }
`;

export const MfaCardStepWrapper = styled.div`
    margin-bottom: 32px;
`;
